import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../app/store";
import { LanguageKeys } from "../../common/language";
import { updateUserResponseAsync } from "../questionnaire/questionnaireSlice";

export interface MessageBarState {
  isOpen: boolean;
  message: LanguageKeys | null;
  status?: "success" | "error" | "info";
}

export const initialState: MessageBarState = {
  isOpen: false,
  message: null,
};

export const messageBarSlice = createSlice({
  name: "messageBar",
  initialState,
  reducers: {
    openMessageBar: (state, action) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.status = action.payload?.status ?? "success";
      return state;
    },
    closeMessageBar: (state) => {
      state.isOpen = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserResponseAsync.rejected, (state) => {
      state.isOpen = true;
      state.message = "messageBar.messages.failure.userDataFailedToSave";
      state.status = "error";
      return state;
    });
  },
});

export const selectMessageBarOpenState = (state: RootState) =>
  state.messageBar.isOpen;
export const selectMessageBarMessage = (state: RootState) =>
  state.messageBar.message;
export const selectMessageBarStatus = (state: RootState) =>
  state.messageBar.status;
export const { openMessageBar, closeMessageBar } = messageBarSlice.actions;
export default messageBarSlice.reducer;
